import React, { useState } from "react";
import {
    ClearableCheckboxDropdown,
    Person,
    Table,
    TimestampFilters,
} from "dyl-components";
import { Table as SemanticTable } from "semantic-ui-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
    getData,
    onToggleTimeUnit,
    useRangeCalendar,
} from "shared/CustomDateRange/customDateRange";
import SortActions from "pages/PhoneManagement/Routing/DestinationGroups/subcomponents/SortActions";
import "../index.scss"
import { useSelector } from "react-redux";
export const Header = ({ onFilter }) => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [isTimeRangeOpen, setTimeRangeOpen] = useState(false);

    const { created_by_users = [] } = useSelector(state => {
        return {
            created_by_users: state.broadcast.created_by_users,
        } || {}
    });
    const {
        timestamp,
        setTimestamp,
        isCustomDateRangeOpen,
        setCustomDateRangeOpen,
        userAuthTimezone,
        dateRange,
        setDateRange,
    } = useRangeCalendar(params);

    const createdOrder =
        params.get("order") === "asc";

    const onDateRangeChange = (_, { value }) => {
        setDateRange(value);
    };

    const createdOrderFilter = () => {
        const query = new URLSearchParams(params);
        const order = !createdOrder ? "asc" : "desc";
        query.set("order", order);
        const query_string = query.toString();
        navigate(
            `/settings/broadcast-message/message-history${query_string ? `?${query_string}` : ""
            }`
        );
    };
    const createdByUsers = created_by_users?.map(user => ({
        key: user.id,
        value: user.id.toString(),
        content: (<label><Person username={user.username} email={user.email} isInactiveUser={!user.active} /></label>)
    }));
    return (
        <Table.Row>
            <SemanticTable.HeaderCell
                className="MessageHistory__MediumFixedWidth"

            >
                <span style={{ marginRight: 5 }}>Date</span>
                <TimestampFilters
                    timestamp={timestamp}
                    onToggleTimeUnit={(timestamp) =>
                        onToggleTimeUnit(
                            timestamp,
                            setTimestamp,
                            params,
                            navigate,
                            "/settings/broadcast-message/message-history"
                        )
                    }
                    areTimeUnitOptionsOpen={isTimeRangeOpen}
                    onOpenTimeUnitOptions={() => setTimeRangeOpen(true)}
                    onCloseTimeUnitOptions={() => setTimeRangeOpen(false)}
                    isCustomDateRangeOpen={isCustomDateRangeOpen}
                    onOpenCustomDateRange={() => {
                        setCustomDateRangeOpen(true);
                        setDateRange("")
                    }}
                    onCloseCustomDateRange={() => {
                        setCustomDateRangeOpen(false);
                    }}
                    dateRange={dateRange}
                    onDateRangeChange={onDateRangeChange}
                    getData={() =>
                        getData({
                            setCustomDateRangeOpen,
                            dateRange,
                            userAuthTimezone,
                            params,
                            navigate,
                            url: "/settings/broadcast-message/message-history"
                        })
                    }
                />

                <SortActions
                    direction={createdOrder}
                    onToggleSort={() => {
                        createdOrderFilter();
                    }}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell

            >
                Message
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell
                className="MessageHistory__MediumFixedWidth"

            >
                <ClearableCheckboxDropdown
                    text="Message Type"
                    name="message_type"
                    options={[
                        { text: 'Maintenance', value: 'Maintenance' },
                        { text: 'Service Interruption', value: 'Service Interruption' },
                        { text: 'Announcement', value: 'Announcement' },
                        { text: 'Warning', value: 'Warning' },
                        { text: 'Other', value: 'Other' },
                    ]}
                    onChange={(_, { value }) => {
                        onFilter(_, { name: "message_type", value });
                    }}
                    value={params.get("message_type")?.split(",")}
                    closeOnLoad={true}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell
                className="MessageHistory__MediumFixedWidth"

            >
                <ClearableCheckboxDropdown
                    text="Permission Type"
                    name="permission_type"
                    options={[
                        { text: 'Owner', value: 'Owner' },
                        { text: 'Administrator', value: 'Administrator' },
                        { text: 'User', value: 'User' },
                        { text: 'Custom', value: 'Custom' },
                    ]}
                    onChange={(_, { value }) => {
                        onFilter(_, { name: "permission_type", value });
                    }}
                    value={params.get("permission_type")?.split(",")}
                    closeOnLoad={true}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell
                className="MessageHistory__MediumFixedWidth"

            >
                <ClearableCheckboxDropdown
                    text="User"
                    name="user_id"
                    options={createdByUsers}
                    onChange={(_, { value }) => {
                        onFilter(_, { name: "user_id", value });
                    }}
                    value={params.get("user_id")?.split(",")}
                />
            </SemanticTable.HeaderCell>

        </Table.Row>
    );
};
